import React, { useContext } from 'react';

import img from '@/assets/not-found.png';
import Button from '@/modules/Button';
import SimplePage from '@/modules/simplePage';
import * as urls from '@/api/urls';
import queryString from 'query-string';
import { deleteSessionStorage } from '@/utils/session';
import { AppContext } from '@/stateManager';

interface IProps {
  location: any;
  history: any;
}

const FatalError = (props: IProps) => {
  //Message and details from the backend
  const { details, message } = queryString.parse(props.location.search);
  const context = useContext<any>(AppContext);
  deleteSessionStorage('_session');

  return (
    <div className="container">
      <SimplePage title={'Undskyld, der er desværre sket en fejl…'}>
        <img loading="lazy" width="530px" height="510px" className="simple-page__image" src={img} />
        <p className="simple-page__text">
          {
            'Der er desværre sket en fejl. Vi prøver at rette op på det hurtigst muligt. Du er velkommen til at prøve igen senere. Fortsætter fejlen kan vi hjælpe dig på '
          }
          <a className="simple-page__text__bold-link" href={`tel:70 70 40 40`}>
            {'70 70 40 40'}
          </a>
          .
        </p>
        {message && <h2>{message}</h2>}
        {details && <p>{details}</p>}
        <Button
          display="block-centered"
          value="Gå til forsiden"
          onClick={() => {
            context.dispatch({ type: 'setFatalError', payload: { fatalError: true } });
            props.history.push(urls.simo.url());
          }}
        />
      </SimplePage>
    </div>
  );
};

export default FatalError;
